import React, { useEffect, createElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Navbar from '../components/Navbar';
const RsvpPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    // Load Luma checkout script
    const script = document.createElement('script');
    script.id = 'luma-checkout';
    script.src = 'https://embed.lu.ma/checkout-button.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      const existingScript = document.getElementById('luma-checkout');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);
  return <div className="min-h-screen bg-cream" data-id="element-290">
      <Navbar data-id="element-291" />

      <div className="section-container pt-24" data-id="element-292">
        <button onClick={() => navigate('/')} className="flex items-center text-gray-700 hover:text-emerald mb-8 transition-colors" data-id="element-293">
          <ArrowLeft size={20} className="mr-2" data-id="element-294" />
          Back to Invitation
        </button>

        <div className="max-w-3xl mx-auto" data-id="element-295">
          <h1 className="section-heading" data-id="element-296">RSVP</h1>
          <p className="text-center text-gray-700 max-w-2xl mx-auto mb-10 font-elegant" data-id="element-297">
            We would be honored to have you join us on our special day. Please
            register your attendance to receive venue details and updates.
          </p>

          <div className="relative bg-white border border-sage border-opacity-60 p-12 rounded-md shadow-lg text-center overflow-hidden" data-id="element-298">
            {/* Decorative background image */}
            <div className="absolute inset-0 opacity-15" data-id="element-299">
              <div className="absolute inset-0 bg-cover bg-center" style={{
              backgroundImage: `url(https://cdn.magicpatterns.com/uploads/pyAJ6rKGgoieVKR4XzyAXR/8_X_10.jpg)`
            }} data-id="element-300" />
            </div>

            {/* Content */}
            <div className="relative z-10" data-id="element-301">
              <div className="mb-8" data-id="element-302">
                <div className="inline-flex items-center justify-center w-20 h-20 bg-sage rounded-full mb-6" data-id="element-303">
                  <span className="text-emerald text-4xl" data-id="element-304">💌</span>
                </div>
                <h2 className="font-script text-4xl text-gray-800 mb-4" data-id="element-305">
                  Join Us on March 14th, 2026
                </h2>
                <p className="text-gray-600 mb-2 font-elegant" data-id="element-306">
                  Ibadan, Oyo State, Nigeria
                </p>
                <p className="text-sm text-gray-500 italic" data-id="element-307">
                  Venue details will be shared with registered guests
                </p>
              </div>

              <a href="https://luma.com/event/evt-T1FUzQc06v9aZvI" className="luma-checkout--button inline-block px-12 py-5 bg-emerald text-white font-sans text-base uppercase tracking-wider hover:bg-emerald-dark transition-all duration-300 shadow-md hover:shadow-lg" data-luma-action="checkout" data-luma-event-id="evt-T1FUzQc06v9aZvI" data-id="element-308">
                RSVP - Join Us Celebrate
              </a>

              <p className="text-xs text-gray-500 mt-6" data-id="element-309">
                Please RSVP by February 28th, 2026
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default RsvpPage;